import _styled from "styled-components";
const _excluded = ["style", "label", "labelProps", "className", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { stylePropType } from '@adsk/alloy-react-theme';

/* These prop are applied by Tabs */

const Tab = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      style,
      label,
      labelProps,
      className,
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({}, props, {
    className: className,
    ref: ref,
    $_css: [style]
  }), children);
});
Tab.displayName = 'Tab';
Tab.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /**  Tab content. Would be visible only when tab is active */
  children: PropTypes.any,
  /**  Tab title */
  label: PropTypes.any,
  /** Icon type */
  renderIcon: PropTypes.func,
  /**  Tab id used for tab selection (has to be unique) */
  tab: PropTypes.string.isRequired,
  /**  onClick event triggered on click tab */
  onClick: PropTypes.func,
  /** Props to pass to label component */
  labelProps: PropTypes.object
};
export default Tab;
var _StyledDiv = _styled("div").withConfig({
  displayName: "Tab___StyledDiv",
  componentId: "sc-5pwhxp-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=Tab.js.map